<script>
import baseMixin from '@/mixins/baseMixin'
import bookingDetailsMixin from '@/mixins/bookingDetailsMixin'
import { mapGetters } from 'vuex'
import BookingPendingApprovalsRejectBookingDialog from '../pendingApprovals/booking-pending-approvals-reject-booking-dialog.vue'

export default {
  name: 'BookingDetailsActionBtn',
  components: {
    BookingPendingApprovalsRejectBookingDialog,
  },
  mixins: [baseMixin, bookingDetailsMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
    },
  },
  data() {
    return {
      showRejectBookingDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingSubmitPendingApproval:
        'bookingApprovals/isLoadingSubmitPendingApproval',
    }),
    showSubmitPendingApprovalButton() {
      return this.canActionBookingRequest(
        this.booking.status,
        this.booking.location.id
      )
    },
  },
  methods: {
    async respondToBookingRequest(action, reason = '') {
      this.$emit('actionEvent', {
        event: 'submitPendingApproval',
        value: {
          action,
          reason,
          bookingId: this.booking.id,
        },
      })
    },
    acceptBookingRequest() {
      return this.respondToBookingRequest('accept')
    },
    promptForReasonOnRejection() {
      this.reasonForRejection = ''
      this.showRejectBookingDialog = true
    },
    rejectBookingRequest(reason) {
      return this.respondToBookingRequest('reject', reason)
    },
  },
}
</script>

<template>
  <div>
    <BaseSplitBtn
      v-if="showSubmitPendingApprovalButton"
      data-testid="booking-action-btn"
      color="primary"
      :dense="dense"
      depressed
      :loading="isLoadingSubmitPendingApproval"
      @click="acceptBookingRequest"
    >
      <p class="mb-0 px-4">{{
        $t('booking.details.actions.sendToAnzukBtn', {
          companyNameShort: $t('app.companyNameShort'),
        })
      }}</p>
      <template v-slot:menu>
        <v-list>
          <v-list-item @click="promptForReasonOnRejection">
            <v-list-item-icon>
              <v-icon>mdi-close</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t('booking.details.actions.rejectBookingBtn')
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </BaseSplitBtn>
    <BookingPendingApprovalsRejectBookingDialog
      v-if="showRejectBookingDialog"
      v-model="showRejectBookingDialog"
      @rejectRequest="rejectBookingRequest"
    />
  </div>
</template>
